import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { Box, Flex, Text } from '@cmpsr/components';
import icons from '@/assets/icons';
import { forwardRef } from 'react';

type TestDetailsSectionProps = {
  icon: keyof typeof icons;
  title: string;
  id: string;
  children: React.ReactNode;
  action?: React.ReactNode;
};

const TestDetailsSection = forwardRef<HTMLDivElement, TestDetailsSectionProps>(
  ({ icon, title, id, children, action }, ref) => {
    return (
      <Box
        as="section"
        bgColor="background-light"
        borderRadius="radii-3"
        p={5}
        border="1px solid"
        borderColor="ui-element-divider"
        id={id}
        ref={ref}
      >
        <IconCatch icon={icon} size="m" mb={4} />

        <Text
          variant={{ base: 'text-body-medium', lg: 'text-body-display-XS' }}
          mb={4}
          fontWeight={600}
          letterSpacing={0}
        >
          {title}
        </Text>

        <Text variant="text-body-regular" mb={action ? 4 : 0}>
          {children}
        </Text>

        {action ? action : null}
      </Box>
    );
  }
);

TestDetailsSection.displayName = 'TestDetailsSection';

export default TestDetailsSection;
